export default "__VITE_ASSET__sNOcEZkh__"